import type jsPDF from 'jspdf';
import { TEAL_RGB } from './letterheadPdf';

type Rgb = [number, number, number];

// Stessi colori delle guide all'offerta (cartella PREVENTIVI): i due documenti vanno insieme al cliente
export const OFFER_TITLE_RGB: Rgb = [11, 79, 83];
export const OFFER_TEXT_RGB: Rgb = [55, 65, 81];
export const OFFER_MUTED_RGB: Rgb = [107, 114, 128];
const OFFER_CARD_RGB: Rgb = [232, 245, 244];

const ACCENT_WIDTH = 1.2;

/** Riquadro verde chiaro con la barra teal a sinistra, come i riquadri delle guide all'offerta. */
export function drawAccentCard(doc: jsPDF, x: number, y: number, width: number, height: number): void {
  doc.setFillColor(...OFFER_CARD_RGB);
  doc.rect(x, y, width, height, 'F');
  doc.setFillColor(...TEAL_RGB);
  doc.rect(x, y, ACCENT_WIDTH, height, 'F');
}
